import { $t } from '@/i18n';
/** 流程单 jobStatus 展示参考。改字面量时按 ../AGENTS.md 同步四处副本。 */
export const FLOW_JOB_STATUS_META = {
    running: { label: $t('k_401e6127'), tone: 'success' },
    pausing: { label: $t('k_3ac73fad'), tone: 'warning' },
    paused: { label: $t('k_d0b565fe'), tone: 'warning' },
    suspended: { label: $t('k_c6f4754'), tone: 'success' },
    aborting: { label: $t('k_9e9f56be'), tone: 'danger' },
    aborted: { label: $t('k_60853982'), isTerminal: true, tone: 'danger' },
    completed: { label: $t('k_2791e342'), isTerminal: true, tone: 'neutral' },
    error: { label: $t('k_db9863ac'), isTerminal: true, tone: 'danger' },
};
